import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const SocialNewsletterContainer = ({
  socialNewsletter,
  socialNewsletterStoreDataKey,
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    socialNewsletterData={socialNewsletter[`${socialNewsletterStoreDataKey}`]}
    {...props}
  />
);

const mapStateToProps = ({ content }) => ({
  socialNewsletter: content.socialNewsletter,
});


SocialNewsletterContainer.propTypes = {
  socialNewsletter: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  socialNewsletterStoreDataKey: PropTypes.string.isRequired,
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(SocialNewsletterContainer);
